cockpitApp.directive('locationSummary', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/location/summary',
    controllerAs: 'locationSummaryCtrl',
    controller: 'locationSummaryController'
  };
});
